import React from 'react'

import '../style.css'
import '../print.css'

import { SidePanelResizable, NoteList, MainPanel } from './Panel'

const Global = ({ children }) => {
  return <div className="position-coverer">{children}</div>
}

const MainBodyContainer = ({ children }) => {
  return (
    <div className="l-main-body u-grid-cell-size-limit background-shade-100 position-relative height-full">
      {children}
    </div>
  )
}

const MainFullContainer = ({ children }) => {
  return (
    <div className="l-main-full u-grid-cell-size-limit background-shade-50">
      {children}
    </div>
  )
}

export {
  SidePanelResizable,
  NoteList,
  MainPanel,
  Global,
  MainBodyContainer,
  MainFullContainer,
}
